/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function WhatsappLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M45.429,176.99811A95.95978,95.95978,0,1,1,79.00277,210.5717l.00023-.001L45.84643,220.044a8,8,0,0,1-9.89-9.89l9.47331-33.15657Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M80.00147,103.535A23.89033,23.89033,0,0,1,104,80h3.47048a8,8,0,0,1,6.85994,3.884l7.41013,12.35021a8,8,0,0,1,.29548,7.69368l-4.7745,9.549-.00127-.00063a36.06864,36.06864,0,0,0,25.26306,25.26334l-.00052-.001,9.54928-4.77464a8,8,0,0,1,7.69368.29548l12.35021,7.41013A8,8,0,0,1,176,148.52952V152a23.89033,23.89033,0,0,1-23.535,23.99853A72.00011,72.00011,0,0,1,80.00147,103.535Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default WhatsappLogo;
